import React from 'react';
import './work.css';
import Works from './Works'


const Work = ({ isDarkMode}) => {
  const bodyClass = `work section ${isDarkMode ? "dark-mode" : ""}`;
   
  return (
    <section className={bodyClass} id="portfolio">
        <h2 className="section__title">Portfolio</h2>
        <span className="section__subtitle">Most recent projects</span>

        <Works isDarkMode={isDarkMode} />
    </section>
  )
}

export default Work
 